import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { PageShell } from '../../shared/components/page-shell/page-shell';
import { ListOfDoctors } from './components/list-of-doctors/list-of-doctors';
import { AbsenceList } from './components/absence-list/absence-list';
import { ListOfShifts } from './components/list-of-shifts/list-of-shifts';
import { DoctorFormModal } from './components/doctor-form-modal/doctor-form-modal';
import { NewShiftModal } from './components/new-shift-modal/new-shift-modal';
import { AppTabs } from '../../shared/components/app-tabs/app-tabs';
import { AppButton } from '../../shared/components/app-button/app-button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { toast } from '../../shared/utils/toast';
import { ToastModule } from 'primeng/toast';
import { Professional, ProfessionalShift } from '../../core/models/professional.model';
import { ProfessionalsService } from '../../core/services/professionals.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-professionals',
  standalone: true,
  imports: [
    CommonModule,
    PageShell,
    ListOfDoctors,
    AbsenceList,
    ListOfShifts,
    DoctorFormModal,
    NewShiftModal,
    TranslateModule,
    TranslateModule,
    AppTabs,
    ConfirmDialogModule,
    ToastModule,
    AppButton
  ],
  providers: [ConfirmationService],
  templateUrl: './professionals.html',
  styleUrl: './professionals.css',
})
export class Professionals {
  constructor(
    private professionalsService: ProfessionalsService,
    private confirmationService: ConfirmationService,
    private translate: TranslateService
  ) { }
  @ViewChild(ListOfDoctors) listOfDoctors?: ListOfDoctors;
  @ViewChild(ListOfShifts) listOfShifts?: ListOfShifts;

  currentTab = 'doctors';

  tabs = [
    { value: 'doctors', label: 'professionals_tab_doctors' },
    { value: 'absences', label: 'professionals_tab_absences' },
    { value: 'shifts', label: 'professionals_tab_shifts' }
  ];

  // Modal states
  showDoctorFormModal = false;
  showNewShiftModal = false;

  selectedProfessional: Professional | null = null;
  selectedShift: ProfessionalShift | null = null;

  selectTab(tabId: string) {
    this.currentTab = tabId;
  }

  // Doctor modal handlers
  onNewDoctor() {
    this.selectedProfessional = null;
    this.showDoctorFormModal = true;
  }

  onEditDoctor(professional: Professional) {
    this.selectedProfessional = professional;
    this.showDoctorFormModal = true;
  }


  closeDoctorFormModal() {
    this.showDoctorFormModal = false;
    this.selectedProfessional = null;
  }


  onDoctorSaved() {
    this.showDoctorFormModal = false;
    this.selectedProfessional = null;
    this.professionalsService.triggerRefreshDoctors();
  }

  // Shift modal handlers
  onNewShift() {
    this.selectedShift = null;
    this.showNewShiftModal = true;
  }

  onEditShift(shift: ProfessionalShift) {
    this.selectedShift = shift;
    this.showNewShiftModal = true;
  }

  onDeleteShift(shift: ProfessionalShift) {
    this.confirmationService.confirm({
      message: this.translate.instant('SHIFT_DELETE_CONFIRMATION_MESSAGE', { name: shift.doctor_name, title: shift.shift_title }),
      header: this.translate.instant('SHIFT_DELETE_CONFIRMATION_TITLE'),
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: this.translate.instant('YES'),
      rejectLabel: this.translate.instant('NO'),
      accept: async () => {
        try {
          const { error } = await this.professionalsService.deleteShift(shift.schedule_id);
          if (error) {
            toast.error(this.translate.instant('error_update'));
          } else {
            toast.success(this.translate.instant('success_update'));
            this.listOfShifts?.refresh();
          }
        } catch (error) {
          toast.error(this.translate.instant('error_update'));
        }
      }
    });
  }

  closeNewShiftModal() {
    this.showNewShiftModal = false;
    this.selectedShift = null;
  }

  onShiftSaved() {
    this.showNewShiftModal = false;
    this.selectedShift = null;
    this.listOfShifts?.refresh();
  }
}
